import { useEffect, useState } from "react";
import { getLedgerByCustomer, putLedgerByCustomer } from "src/shared/services/servicesv2";
import { LedgerDetails } from "src/shared/services/interfacev2";
import { notifyError, notifySuccess } from "src/assets/toastService";

export const useLedgerFetch = (
  customerId: string,
  page: number,
  rowsPerPage: number,
  includeHistory: boolean,
  sortField: string,
  sortOrder: "asc" | "desc"
) => {
  const [customerData, setCustomerData] = useState<LedgerDetails | null>(null);
  const [loading, setLoading] = useState(false);
  const now = new Date();
  const localDate = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");


  const [paginationData, setPaginationData] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: page,
    pageSize: rowsPerPage,
  });

  const fetchData = async () => {
    if (!customerId) return;

    setLoading(true);

    try {
      const res = await getLedgerByCustomer(
        customerId,
        page + 1, // ✅ FIXED (API is 1-based)
        rowsPerPage,
        includeHistory,
        sortField,
        sortOrder
      );

      const response = res?.data || {};

      if (response?.ledger) {
        setCustomerData(response.ledger);

        const totalRecords =
          response.totalRecords ??
          (includeHistory
            ? response.ledger.orderHistory?.length
            : response.ledger.orderDetails?.length) ??
          0;

        setPaginationData({
          totalRecords,
          totalPages: Math.ceil(totalRecords / rowsPerPage),
          currentPage: page,
          pageSize: rowsPerPage,
        });
      }
    } catch (error) {
      console.error("Error fetching ledger data:", error);
      setCustomerData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [customerId, page, rowsPerPage, includeHistory, sortField, sortOrder]);

  const updatesLedgerLimit = (customerId: string, newLimit: number) => {
    setLoading(true);
    putLedgerByCustomer(customerId, {
      creditLimit: { defaultLimit: newLimit },
      date: localDate,
      time: now.toTimeString().split(" ")[0],
    },)
      .then(() => {
        notifySuccess("Credit limit updated successfully.");
        fetchData(); // ✅ Refresh ledger data after update
      }).catch((error) => {
        notifyError(error || "Failed to update credit limit.");
        setLoading(false);
      });
  };

  return { customerData, paginationData, loading, refetch: fetchData, updatesLedgerLimit };
};